import React, { useState } from 'react';
import { useTranslation } from 'react-i18next';
import { Paper, Text, Button, Group, Code, CopyButton, Tooltip, ActionIcon, Anchor } from '@mantine/core';
import { Check, Copy } from '@phosphor-icons/react';
import api from '../utils/api';

/**
 * Settings section: connect the user's Droid account to Claude Code / any MCP
 * client. Shows their API token baked into a ready-to-paste `claude mcp add`
 * command. See docs/MCP.md and ads/mcp_server.py.
 */
export default function McpIntegration() {
  const { t } = useTranslation();
  const [data, setData] = useState(null);
  const [loading, setLoading] = useState(false);

  const load = () => {
    setLoading(true);
    api.get('/accounts/api-token/')
      .then(r => setData(r.data))
      .catch(() => {})
      .finally(() => setLoading(false));
  };

  return (
    <Paper withBorder p="md" mt="xl" maw={620}>
      <Text size="sm" fw={600} mb={4}>{t('conversions.mcp.title')}</Text>
      <Text size="xs" c="dimmed" mb="sm">
        {t('conversions.mcp.description')}
      </Text>
      {!data ? (
        <Button size="xs" variant="light" color="brand" loading={loading} onClick={load}>
          {t('conversions.mcp.showToken')}
        </Button>
      ) : (
        <>
          <Text size="xs" fw={500} mb={2}>{t('conversions.mcp.commandLabel')}</Text>
          <Group gap={6} wrap="nowrap" align="flex-start">
            <Code block style={{ fontSize: 11, flex: 1, whiteSpace: 'pre-wrap', wordBreak: 'break-all' }}>
              {data.mcp_add_command}
            </Code>
            <CopyButton value={data.mcp_add_command}>
              {({ copied, copy }) => (
                <Tooltip label={copied ? t('conversions.mcp.copied') : t('conversions.mcp.copy')} withArrow>
                  <ActionIcon variant="subtle" color={copied ? 'green' : 'gray'} onClick={copy}>
                    {copied ? <Check size={15} /> : <Copy size={15} />}
                  </ActionIcon>
                </Tooltip>
              )}
            </CopyButton>
          </Group>
          <Text size="10px" c="dimmed" mt={6}>
            {t('conversions.mcp.tokenWarning')}
          </Text>
        </>
      )}
    </Paper>
  );
}
